const comments = [
  {
    name: '漫迷小K',
    avatar: 'K',
    color: 'bg-accent-500',
    time: '2天前',
    text: '用韩漫之家下载的APK看了一个月了，离线功能真的很方便，地铁上也能流畅看，画质也很清晰！推荐给所有韩漫爱好者。',
  },
  {
    name: '追更达人',
    avatar: '追',
    color: 'bg-primary-500',
    time: '5天前',
    text: '之前一直找不到好用的韩漫下载工具，试了韩漫之家推荐的几个APP都不错，更新速度也快，终于不用到处找资源了。',
  },
  {
    name: '深夜读漫',
    avatar: '夜',
    color: 'bg-secondary-500',
    time: '1周前',
    text: '离线韩漫真的是刚需，晚上躺床上没有WiFi也能看，已经安利给身边的漫友了，大家都说好用。',
  },
  {
    name: '韩漫老粉',
    avatar: '粉',
    color: 'bg-accent-600',
    time: '2周前',
    text: '入坑韩漫三年了，韩漫之家的专题合集做得非常好，分类清晰，还能找到很多冷门好作品，比我自己到处搜效率高多了。',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者反馈
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            来自真实韩漫读者的使用体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className={`w-10 h-10 rounded-full ${comment.color} flex items-center justify-center text-background-50 text-sm font-bold shrink-0`}
                >
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="flex items-center gap-0.5 text-accent-500 shrink-0">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}